import React, { useState } from "react";
import { Accordion, Grid, Icon, Input, TextArea } from "semantic-ui-react";
import {
  API_HOST,
  getTextFromObject,
  invoicingFrequencyOptions,
  receiverTypeOptions,
  updateDataToObj,
} from "..";
import { IBankAccount, IContractCard, IForm } from "../types";

export const Summary = (props) => {
  const { inputData, nextStep } = props;
  const [outputData, setOutputData] = useState<IForm>(inputData);
  const [accordionIndex, setAccordionIndex] = useState<number>(0);
  const [isError, setIsError] = useState<boolean>(false);
  const [isSending, setIsSending] = useState<boolean>(false);

  const handleAccordionClick = (e) => {
    setAccordionIndex(accordionIndex === 0 ? 1 : 0);
  };

  const inputChange = (path, value, index = -1, extraKey = "") => {
    const tempData = updateDataToObj(outputData, path, value, index, extraKey);
    setOutputData({ ...tempData });
  };

  const convertOutput = (data: IForm) => {
    data.contractConditions.totalLimit = parseInt(
      data.contractConditions.totalLimit.toString().replace(/\D/g, "")
    );
    data.contractConditions.cardsNumber = parseInt(
      data.contractConditions.cardsNumber.toString().replace(/\D/g, "")
    );
    data.contractConditions.invoicingFrequency = parseInt(
      data.contractConditions.invoicingFrequency.toString().replace(/\D/g, "")
    );
    data.contractConditions.paymentDelay = parseInt(
      data.contractConditions.paymentDelay.toString().replace(/\D/g, "")
    );
    data.contractConditions.contractCards.forEach((card: IContractCard) => {
      card.cardNo = parseInt(card.cardNo.toString().replace(/\D/g, ""));
      card.cardLimit = parseInt(card.cardLimit.toString().replace(/\D/g, ""));
    });
    data.billingData.bankAccounts.forEach((bank: IBankAccount) => {
      bank.bankAccountNumber = bank.bankAccountNumber.replace(/ /g, "");
    });

    return data;
  };

  const handleSubmit = () => {
    console.log("submit: ", outputData);
    setIsSending(true);

    fetch(API_HOST + "/contractor/lead", {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/json",
      },
      body: JSON.stringify(convertOutput(outputData)),
    })
      .then((res) => {
        //400 blad walidacji
        if (res.status === 200) {
          return res.json();
          // nextStep(100);
        } else {
          setIsSending(false);
          setIsError(true);
          setTimeout(() => {
            setIsError(false);
          }, 3000);
          throw new Error(res.status + " - błąd serwera");
        }
      })
      .then((data) => {
        if (data.status === 200) {
          nextStep(100);
        } else {
          setIsSending(false);
          setIsError(true);
          setTimeout(() => {
            setIsError(false);
          }, 3000);
          throw new Error(data.status + " - błąd serwera");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setIsSending(false);
      });
  };

  return (
    <div className="m-form__step m-form__step--summary">
      <h2 className="m-form__header">Podsumowanie</h2>
      <p className="m-form__text">
        Prosimy o uważne sprawdzenie danych, zwłaszcza adresów email oraz danych
        bankowych.
      </p>

      <h2 className="m-form__header">Dane Wnioskującego</h2>

      <div className="m-form__block">
        <h3 className="m-form__subheader">Dane Wnioskującego</h3>

        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column width={8}>
              <dl>
                <dt>Nazwa</dt>
                <dd>{outputData.receiver.receiverName}</dd>

                <dt>NIP</dt>
                <dd>{outputData.receiver.receiverNIP}</dd>

                <dt>Rodzaj działalności</dt>
                <dd>
                  {getTextFromObject(
                    receiverTypeOptions,
                    outputData.receiver.receiverType
                  )}
                </dd>
                {!(outputData.receiver.receiverType == 10) && (
                <>
                    <dt>Czy Firma jest zarejestrowana od min. 12 miesięcy?</dt>
                    <dd>
                      {outputData.receiver.receiverRegisterPeriod ? (
                      <>
                        <div className="blue-dot">Tak</div>
                      </>
                      ) : (
                      <>
                        <div className="blue-dot">Nie</div>
                      </>
                      )}
                    </dd>   
   
                    <dt>Czy podmiot jest zarejestrowanym podatnikiem VAT?</dt>
                    <dd>    
                    {outputData.receiver.receiverRegisterVat ? (
                      <>
                        <div className="blue-dot">Tak</div>
                      </>
                      ) : (
                      <>
                        <div className="blue-dot">Nie</div>
                      </>
                      )}
                    </dd>  
                  </>
                )}
              </dl>
            </Grid.Column>
            <Grid.Column width={8}>
              <dl>
                <dt>Ulica</dt>
                <dd>{outputData.receiver.receiverAddress.street}</dd>

                <dt>Nr domu</dt>
                <dd>{outputData.receiver.receiverAddress.houseNo}</dd>

                {outputData.receiver.receiverAddress.flatNo && (
                  <>
                    <dt>Nr mieszkania</dt>
                    <dd>{outputData.receiver.receiverAddress.flatNo}</dd>
                  </>
                )}

                <dt>Kod pocztowy</dt>
                <dd>{outputData.receiver.receiverAddress.zipCode}</dd>

                <dt>Miasto</dt>
                <dd>{outputData.receiver.receiverAddress.city}</dd>

                <dt>Kraj</dt>
                <dd>{outputData.receiver.receiverAddress.country}</dd>
              </dl>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>

      <div className="m-form__block">
        <h3 className="m-form__subheader">Reprezentacja</h3>
        {outputData.receiver.receiverRepresentatives.map((rep, index) => (
          <div key={"rep__" + index}>
            <dl>
              <dt>Imię pełnomocnika</dt>
              <dd>{rep.representativeName}</dd>
            </dl>
            <dl>
              <dt>Nazwisko pełnomocnika</dt>
              <dd>{rep.representativeSurname}</dd>
            </dl>

            {/* {outputData.receiver.receiverType == 30 && (
              <dl>
                <dt>
                  Telefon do jednorazowego kontaktu w celu potwierdzenia
                  szczegółów wniosku
                </dt>
                <dd>{rep.representativePhone}</dd>
              </dl>
            )} */}

            {outputData.receiver.receiverType == 20 && (
              <>
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <dl>
                        <dt>Numer dowodu osobistego</dt>
                        <dd>{rep.representativeID}</dd>
                      </dl>
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <dl>
                        <dt>Pesel</dt>
                        <dd>{rep.representativePesel}</dd>
                      </dl>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="m-form__block">
        <h3 className="m-form__subheader">Nabywca</h3>

        {outputData.buyer.sameAsReceiver ? (
          <>
            <div className="blue-dot">Ten sam co Wnioskujący</div>
          </>
        ) : (
          <>
            <div className="blue-dot">Różny od Odbiorcy</div>

            <Grid columns={2}>
              <Grid.Row>
                <Grid.Column width={8}>
                  <dl>
                    <dt>Nazwa</dt>
                    <dd>{outputData.buyer.buyerCompanyName}</dd>

                    <dt>NIP</dt>
                    <dd>{outputData.buyer.buyerNIP}</dd>

                    <dt>Nazwa płatnika (jeśli inny)</dt>
                    <dd>{outputData.buyer.buyerPayerName}</dd>

                    <dt>Adres płatnika (jeśli inny)</dt>
                    <dd>{outputData.buyer.buyerPayerAddress}</dd>
                  </dl>
                </Grid.Column>
                <Grid.Column width={8}>
                  <dl>
                    <dt>Ulica</dt>
                    <dd>{outputData.buyer.buyerAddress.street}</dd>

                    <dt>Nr domu</dt>
                    <dd>{outputData.buyer.buyerAddress.houseNo}</dd>

                    {outputData.buyer.buyerAddress.flatNo && (
                      <>
                        <dt>Nr mieszkania</dt>
                        <dd>{outputData.buyer.buyerAddress.flatNo}</dd>
                      </>
                    )}

                    <dt>Kod pocztowy</dt>
                    <dd>{outputData.buyer.buyerAddress.zipCode}</dd>

                    <dt>Miasto</dt>
                    <dd>{outputData.buyer.buyerAddress.city}</dd>

                    <dt>Kraj</dt>
                    <dd>{outputData.buyer.buyerAddress.country}</dd>
                  </dl>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </>
        )}
      </div>

      <div className="m-form__block">
        <h3 className="m-form__subheader">Składający wniosek</h3>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column width={8}>
              <dl>
                <dt>Imię i nazwisko</dt>
                <dd>{outputData.applicant.applicantName}</dd>

                {outputData.applicant.applicantPosition != "" && (
                  <>
                    <dt>Funkcja lub Stanowisko</dt>
                    <dd>{outputData.applicant.applicantPosition}</dd>
                  </>
                )}
              </dl>
            </Grid.Column>
            <Grid.Column width={8}>
              <dl>
                <dt>Adres e-mail</dt>
                <dd>{outputData.applicant.applicantPhone}</dd>

                <dt>Numer telefonu</dt>
                <dd>{outputData.applicant.applicantEmail}</dd>
              </dl>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>

      <h2 className="m-form__header">Dane do rozliczeń i kontaktu</h2>
      <div className="m-form__block">
        <h3 className="m-form__subheader">
          Dane do wysyłki faktur i dokumentów rozliczeniowych
        </h3>
        <dl>
          <dt>E-mail</dt>
          {outputData.billingData.billingEmails.map((email, index) => (
            <dd key={"email__" + index}>{email}</dd>
          ))}
        </dl>
      </div>
      <div className="m-form__block">
        <h3 className="m-form__subheader">Dane bankowe wnioskującego</h3>
        {outputData.billingData.bankAccounts.map((account, index) => (
          <Grid columns={2} key={"acc__" + index}>
            <Grid.Row>
              <Grid.Column width={8}>
                <dl>
                  <dt>Nazwa banku</dt>
                  <dd>{account.bankName}</dd>
                </dl>
              </Grid.Column>
              <Grid.Column width={8}>
                <dl>
                  <dt>Numer rachunku PLN</dt>
                  <dd>{account.bankAccountNumber}</dd>
                </dl>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        ))}
      </div>
      <div className="m-form__block">
        <h3 className="m-form__subheader">Dane kontaktowe</h3>
        {outputData.contactDetails.map((contact, index) => (
          <div key={"cont__" + index}>
            <dl>
              <dt>Imię i nazwisko</dt>
              <dd>{contact.contactName}</dd>
            </dl>
            <Grid columns={2}>
              <Grid.Row>
                <Grid.Column width={7}>
                  <dl>
                    <dt>Numer telefonu</dt>
                    <dd>{contact.contactPhone}</dd>
                  </dl>
                </Grid.Column>
                <Grid.Column width={9}>
                  <dl>
                    <dt>E-mail</dt>
                    <dd>{contact.contactEmail}</dd>
                  </dl>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <br />
          </div>
        ))}
      </div>
      <h2 className="m-form__header">Wnioskowane Warunki Umowy</h2>
      <div className="m-form__block">
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column width={8}>
              <dl>
                <dt>Limit ogólny</dt>
                <dd>
                  {parseInt(
                    outputData.contractConditions.totalLimit
                      .toString()
                      .replace(/\D/g, "")
                  )}{" "}
                  PLN
                </dd>

                <dt>Liczba kart</dt>
                <dd>
                  {parseInt(
                    outputData.contractConditions.cardsNumber
                      .toString()
                      .replace(/\D/g, "")
                  )}{" "}
                  sztuk
                </dd>
              </dl>
            </Grid.Column>
            <Grid.Column width={8}>
              <dl>
                <dt>Częstotliwość wysyłania faktur</dt>
                <dd>
                  {getTextFromObject(
                    invoicingFrequencyOptions,
                    outputData.contractConditions.invoicingFrequency
                  )}
                </dd>

                <dt>Termin odroczenia i prowizja</dt>
                <dd>{outputData.contractConditions.paymentDelay} dni</dd>
              </dl>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
      <h2 className="m-form__header">Konfiguracja kart</h2>
      <div className="m-form__block">
        <Grid columns={3}>
          <Grid.Row className="m-form__subheader">
            <Grid.Column width={10}>Suma limitów kart:</Grid.Column>
            <Grid.Column width={6} textAlign="right">
              {`${parseInt(
                outputData.contractConditions.totalLimit
                  .toString()
                  .replace(/\D/g, "")
              )} PLN`}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="m-form__gridheader">
            <Grid.Column width={5}>Numer karty</Grid.Column>
            <Grid.Column width={5}>Limit karty</Grid.Column>
            <Grid.Column width={6}>
              Numer telefonu użytkownika karty
            </Grid.Column>
          </Grid.Row>
          {outputData.contractConditions.contractCards.map((card, index) => (
            <Grid.Row className="m-form__row" key={"card__" + index}>
              <Grid.Column width={5}>
                {`KartaPartner#${card.cardNo}`}
              </Grid.Column>
              <Grid.Column width={5}>{`${card.cardLimit} PLN`}</Grid.Column>
              <Grid.Column width={6}>{`${card.cardPhoneNumber}`}</Grid.Column>
            </Grid.Row>
          ))}
        </Grid>
      </div>
      <h2 className="m-form__header">Informacje dodatkowe</h2>
      <div className="m-form__block">
        <div className={`m-form__field`}>
          {/* <label>Informacje dodatkowe</label> */}
          <div className="m-form__component ">
            <TextArea
              // style={{ minHeight: 100 }}
              maxLength={256}
              rows={4}
              placeholder="Np. inny adres do korespondencji niż adres Odbiorcy/ inne uwagi"
              name="additionalNotes"
              value={outputData.additionalNotes}
              onChange={(e) => {
                inputChange("additionalNotes", e.target.value);
              }}
            />
          </div>
        </div>
      </div>
      <div className="m-form__block">
        <Accordion>
          <Accordion.Title
            active={accordionIndex === 1}
            onClick={handleAccordionClick}
          >
            <span className="m-form__subheader">Klauzula informacyjna</span>
          </Accordion.Title>
          <Accordion.Content active={accordionIndex === 1}>
            <p>
              Dotyczy administrowania danymi osobowymi. Przesłanie wypełnionego
              wniosku oznacza potwierdzenie zapoznania się z treścią klauzuli
              oraz jej akceptację.
            </p>
            <ol>
              <li>
                Administratorem danych osobowych podanych we wniosku jest
                Castorama Polska Sp. z o.o., z siedzibą w Warszawie (02-255),
                przy ul. Krakowiaków 78, KRS 0000024785 (dalej jako „Castorama”
                lub „Administrator”).
              </li>
              <li>
                Kontakt z Inspektorem Ochrony Danych możliwy jest pod adresem:
                IOD@castorama.pl lub pod ww. adresem siedziby, z dopiskiem
                „Inspektor Ochrony Danych”.
              </li>
              <li>
                Dane osobowe będą przetwarzane: <br />
                a) w celu podjęcia działań na żądanie osoby, której dane
                dotyczą, tj. rozpatrzenia wniosku przed zawarciem umowy ramowej
                o współpracy w sprawie sprzedaży z odroczonym terminem płatności
                (dalej „Umowy”) oraz do jej wykonania, w oparciu o art. 6 ust.
                1. lit. b Rozporządzenia Ogólnego o Ochronie Danych Osobowych
                (dalej: „RODO”) lub art. 6 ust. 1 lit. f RODO (w przypadku
                danych osobowych niepozyskanych od osoby, której dane dotyczą,
                np. danych członków organów, osób kontaktowych Wnioskodawcy)
                oraz <br />
                b) na podstawie art. 6 ust. 1 lit. f RODO tj. prawnie
                uzasadnionego interesu Administratora, jakim jest ewentualne
                dochodzenie i obrona przed roszczeniami związanymi z Umową.
              </li>
              <li>
                Podanie przez Wnioskodawcę danych osobowych jest dobrowolne,
                jednakże stanowi warunek niezbędny do zawarcia Umowy.{" "}
              </li>
              <li>
                Dane osobowe mogą być przekazane podmiotom przetwarzającym je na
                zlecenie Administratora, w szczególności podmiotom świadczącym
                usługi IT również spoza UE, tylko w celu i zakresie niezbędnym
                dla realizacji ww. celu, przy czym takie podmioty przetwarzają
                dane na podstawie umów zawartych z Administratorem i wyłącznie
                zgodnie z poleceniami Administratora. Zgodnie z przepisami
                ochrony danych, bezpieczeństwo przy przetwarzaniu danych poza
                EOG gwarantuje stosowanie zewnętrznych umów dotyczących
                przetwarzania danych w oparciu o standardowe klauzule umowne
                zatwierdzone przez UE lub decyzje Komisji Europejskiej
                stwierdzające odpowiedni poziom ochrony danych osobowych.
                Ponadto odbiorcami danych mogą być podmioty upoważnione do tego
                na podstawie przepisów prawa oraz podmiot będący faktorem tj.
                Faktoria Spółka z ograniczoną odpowiedzialnością z siedzibą w
                Warszawie, pod adresem: ul. Wołoska 24, 02-675 Warszawa.{" "}
              </li>
              <li>
                Dane osobowe będą przechowywane przez okres trwania Umowy oraz
                czas przedawnienia roszczeń z nią związanych, a w przypadku
                niezawarcia Umowy – przez czas przedawnienia roszczeń związanych
                ze złożeniem wniosku.
              </li>
              <li>
                Osobom, których dane dotyczą, przysługuje prawo żądania dostępu
                do treści swoich danych, ich sprostowania, usunięcia,
                przenoszenia, ograniczenia przetwarzania, wniesienia sprzeciwu
                oraz złożenia skargi do Prezesa Urzędu Ochrony Danych Osobowych.
              </li>
              <li>
                Źródłem danych osobowych (w przypadku danych osobowych
                niepozyskanych od osoby, której dane dotyczą, np. danych
                członków organów, osób kontaktowych) jest Wnioskodawca, który
                wskazał ww. osoby jako swoich reprezentantów i/lub osoby do
                kontaktu z jego ramienia, jako osoby odpowiedzialne za wykonanie
                Umowy.
              </li>
            </ol>
          </Accordion.Content>
        </Accordion>
      </div>

      {isError && (
        <div className="m-form__error">
          Wystąpił problem z wysyłką. Spróbuj ponownie za chwilę lub sprawdź
          poprawność wypełnionych pól.
        </div>
      )}
      <div className="m-form__btns">
        <button
          type="button"
          className="m-form__btn m-form__btn--next m-form__btn--submit"
          onClick={handleSubmit}
          disabled={isSending}
        >
          <span>Wysyłam wniosek</span>
        </button>
        <button
          type="button"
          className="m-form__btn m-form__btn--back"
          onClick={() => {
            nextStep(4);
          }}
        >
          Powrót
        </button>
      </div>
    </div>
  );
};
